/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Layout_RenameInputs */

const vi_sidebar_layout_rename = /** @type {(inputs: Sidebar_Layout_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi tên`)
};

/**

* @param {Sidebar_Layout_RenameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sidebar_layout_rename = /** @type {((inputs?: Sidebar_Layout_RenameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Layout_RenameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sidebar_layout_rename(inputs)
});